import { Subject } from 'rxjs'

export const eventSubject = new Subject<string>()
